export default "__VITE_ASSET__Bmf7IxdW__"